import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";

export const Newsletter = () => {
  const [email, setEmail] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }
    toast.success("Welcome to the Scholarly Dispatch — check your inbox soon.");
    setEmail("");
  };

  return (
    <section data-testid="newsletter-section" className="relative">
      <div className="relative w-full bg-[var(--ink)] overflow-hidden py-20 lg:py-28 px-6 sm:px-12 lg:px-20">
        <div className="absolute -top-20 -right-16 h-80 w-80 rounded-full bg-[var(--gold)]/10 blur-3xl" />
        <div className="absolute -bottom-24 -left-10 h-72 w-72 rounded-full bg-[var(--terracotta)]/10 blur-3xl" />
        <div
          className="absolute inset-0 pointer-events-none opacity-[0.06]"
          style={{
            backgroundImage:
              "radial-gradient(circle at 15% 30%, #C5A059 0, transparent 45%)",
          }}
        />

        <div className="relative max-w-6xl mx-auto grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <span className="font-mono text-xs uppercase tracking-[0.28em] text-[var(--gold)]">
              The Scholarly Dispatch
            </span>
            <h2 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.03] text-[#F9F6F0]">
              Monthly research notes from the devata archive
            </h2>
            <p className="mt-5 font-sans text-base sm:text-lg text-[#D9CDB6] leading-relaxed max-w-md">
              New discoveries, publication announcements and rare images from
              Angkor — delivered once a month. No noise.
            </p>
          </div>

          <form onSubmit={submit} className="w-full">
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                data-testid="newsletter-email-input"
                className="flex-1 rounded-full bg-[#F9F6F0]/5 border border-[#F9F6F0]/20 px-6 py-4 font-sans text-sm text-[#F9F6F0] placeholder:text-[#8C8373] focus:outline-none focus:border-[var(--gold)] transition-colors"
              />
              <button
                type="submit"
                data-testid="newsletter-submit-button"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-[var(--gold)] text-[var(--ink)] px-8 py-4 font-sans text-sm font-semibold hover:bg-[#E8C877] transition-colors duration-300"
              >
                Subscribe <Send className="h-4 w-4" />
              </button>
            </div>
            <p className="mt-4 font-sans text-xs text-[#8C8373]">
              Join scholars, collectors and travelers who follow the women of Angkor Wat.
            </p>
          </form>
        </div>
      </div>
    </section>
  );
};
